import { useEffect } from 'react';
import { usePlanOverageUsageData } from 'assets/js/pages/account-settings/account-about/givebutter-plus/usePlanOverageUsageData';
import { useAccountLocalStorage } from 'contexts/useAccountLocalStorage';
import { useRecommendedPlanComparison } from 'customHooks/useRecommendedPlanComparison';

const useResetOverageWarningStoresWhenResolved = () => {
    const { isRecommendedPlanCheaper } = useRecommendedPlanComparison();
    const { over80, over90, over100 } = usePlanOverageUsageData();

    const {
        setHasDismissed80WarningBanner,
        setHasDismissed90WarningBanner,
        setHasDismissed100WarningBanner,
        setHasDismissedOveragesWarningGracePeriodBanner,
        setHasDismissedOveragesWarningBanner,
        //
        setHasDismissedOveragesWarningGracePeriodBilling,
        setHasDismissedOveragesWarningBilling,
    } = useAccountLocalStorage(
        ({
            setHasDismissed80WarningBanner,
            setHasDismissed90WarningBanner,
            setHasDismissed100WarningBanner,
            setHasDismissedOveragesWarningGracePeriodBanner,
            setHasDismissedOveragesWarningBanner,
            //
            setHasDismissedOveragesWarningGracePeriodBilling,
            setHasDismissedOveragesWarningBilling,
        }) => {
            return {
                setHasDismissed80WarningBanner,
                setHasDismissed90WarningBanner,
                setHasDismissed100WarningBanner,
                setHasDismissedOveragesWarningGracePeriodBanner,
                setHasDismissedOveragesWarningBanner,
                //
                setHasDismissedOveragesWarningGracePeriodBilling,
                setHasDismissedOveragesWarningBilling,
            };
        },
    );

    useEffect(() => {
        if (!over80) {
            setHasDismissed80WarningBanner(false);
        }
    }, [over80, setHasDismissed80WarningBanner]);

    useEffect(() => {
        if (!over90) {
            setHasDismissed90WarningBanner(false);
        }
    }, [over90, setHasDismissed90WarningBanner]);

    useEffect(() => {
        if (!over100) {
            setHasDismissed100WarningBanner(false);
        }
    }, [over100, setHasDismissed100WarningBanner]);

    useEffect(() => {
        if (!isRecommendedPlanCheaper) {
            setHasDismissedOveragesWarningGracePeriodBanner(false);
            setHasDismissedOveragesWarningBanner(false);
            setHasDismissedOveragesWarningGracePeriodBilling(false);
            setHasDismissedOveragesWarningBilling(false);
        }
    }, [
        isRecommendedPlanCheaper,
        setHasDismissedOveragesWarningGracePeriodBanner,
        setHasDismissedOveragesWarningBanner,
        setHasDismissedOveragesWarningGracePeriodBilling,
        setHasDismissedOveragesWarningBilling,
    ]);
};

export { useResetOverageWarningStoresWhenResolved };
